var map = {
	"./ada.jpg": [
		1748,
		748
	],
	"./basic.jpg": [
		984,
		984
	],
	"./cobol.jpg": [
		1747,
		747
	],
	"./dart.jpg": [
		3424
	],
	"./desk-1.jpg": [
		5814
	],
	"./desk-2.jpg": [
		2311,
		311
	],
	"./erlang.jpg": [
		5698,
		698
	],
	"./fortran.jpg": [
		9449,
		449
	],
	"./go.jpg": [
		4101,
		101
	],
	"./haskell.jpg": [
		9873,
		873
	],
	"./idris.jpg": [
		1009,
		9
	],
	"./java.jpg": [
		2729,
		729
	],
	"./kotlin.jpg": [
		5689
	],
	"./lisp.jpg": [
		2634,
		634
	],
	"./meetingroom.jpg": [
		3810,
		810
	],
	"./modula.jpg": [
		5245,
		245
	],
	"./neko.jpg": [
		821,
		821
	],
	"./octave.jpg": [
		9665,
		665
	],
	"./python.jpg": [
		5163,
		163
	],
	"./q.jpg": [
		1882,
		882
	],
	"./staff-hall-1.jpg": [
		7431
	],
	"./staff-hall-2.jpg": [
		6128,
		128
	],
	"./staff-hall-3.jpg": [
		6923
	],
	"./staff-hall-4.jpg": [
		9215,
		215
	],
	"./student-hall-1.jpg": [
		8389
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7667;
module.exports = webpackAsyncContext;